import { Game } from './core';

// Mobile viewport height fix
function setMobileViewportHeight(): void {
  // Set CSS custom property for viewport height
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// Initialize mobile viewport fix
setMobileViewportHeight();

// Update viewport height on resize/orientation change
window.addEventListener('resize', setMobileViewportHeight);
window.addEventListener('orientationchange', () => {
  // Delay the viewport calculation to account for browser UI changes
  setTimeout(setMobileViewportHeight, 100);
});

// Initialize the game when the page loads
let game: Game;

function init(): void {
  try {
    game = new Game();
    console.log('Game initialized successfully!');
  } catch (error) {
    console.error('Failed to initialize game:', error);
  }
}

// Handle page visibility for performance
document.addEventListener('visibilitychange', () => {
  // You can pause/resume game here if needed
  if (document.hidden) {
    console.log('Game paused');
  } else {
    console.log('Game resumed');
  }
});

// Cleanup on page unload
window.addEventListener('beforeunload', () => {
  if (game) {
    game.destroy();
  }
});

// Start the game 
init();
